import { FilterFactory } from "src/app/search/models/filter-factory.interface";
import { IFilter, IFilterOperator } from "src/app/search/models/filter.interface";

export class UserNameFilterFactory extends FilterFactory {
  field = {
    label: "User Name",
    queryValue: "userName"
  };

  operators: IFilterOperator[] = [
    {
      label: "is equal to",
      operator: " : "
    },
    {
      label: "is not equal to",
      operator: " ! "
    }
  ];

  build(): IFilter {
    return this.createFilterStructure(
      ` ${this.field.queryValue} ${this.selectedOperator!.operator} '${this.selectedCriteria?.toString()}' `
    );
  }
}

